import K from "utilities/constants";
import {
  isPermissionPresent,
  removeUnderScore,
  toolTipRemoveUnderScore,
} from "utilities/generalUtility";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";
import { EditIconButton } from "../../../common/components/iconButton/editIconButton";

const actionColumnRenderer = (roles, editHandler) => (params) => (
  <>
    {isPermissionPresent(K.Permissions.EditClientBilling, roles) && (
      <EditIconButton onClick={() => editHandler(params.data)} />
    )}
  </>
);

const tooltipIsAssignable = (params) => (
  <div className="client-list-tooltip">
    {params.data.isAssignable ? "Assignable" : "UnAssignable"}
  </div>
);

const isAssignable = (params) =>
  params.data.isAssignable ? "Assignable" : "UnAssignable";

export const getColumns = (roles, editHandler) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Name",
    field: "name",
    sortable: true,
    sort: "asc",
    tooltipField: "name",
  },
  {
    headerName: "Type",
    field: "type",
    sortable: true,
    tooltipField: "type",
    tooltipComponent: (params) => toolTipRemoveUnderScore(params.value),
    cellRenderer: (params) => removeUnderScore(params.value),
  },
  {
    headerName: "Status",
    field: "isAssignable",
    sortable: true,
    tooltipField: "isAssignable",
    tooltipComponent: tooltipIsAssignable,
    cellRenderer: isAssignable,
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditClientBilling, roles),
    cellRenderer: actionColumnRenderer(roles, editHandler),
  },
];
